import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import { performApiRequest, getApiDataRequest, invalidateApiDataRequest } from '../../redux/apiData';
import { openModal } from '../../redux/modal';
import { textStyles, colorPalette, shadows, fonts } from '../../styles/styleGuide';
import { toBreakpoint } from '../../styles/breakpoints';
import BannerBlock from './../BannerBlock';
import FormGenerator from '../shared/forms/FormGenerator';
import getLinkFromPageObject from '../../services/getLinkFromPageObject';
import get from 'lodash.get';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    postActivationCodeRequest: getApiDataRequest(state.apiData, 'postActivationCode', {
      projectSlug: String(ownProps.match.params.projectSlug)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    postActivationCode: function postActivationCode(projectSlug, values) {
      dispatch(performApiRequest('postActivationCode', {
        projectSlug: projectSlug
      }, values));
    },
    openNextModal: function openNextModal(modalObject) {
      dispatch(openModal(colorPalette.lightOrange, modalObject));
    },
    getNewSettingsAndPage: function getNewSettingsAndPage(projectSlug) {
      var pagePath = getLinkFromPageObject({
        projectSlug: projectSlug,
        env: 'closed'
      });
      dispatch(invalidateApiDataRequest('getSettings', {
        projectSlug: projectSlug,
        env: 'closed'
      }));
      dispatch(invalidateApiDataRequest('getPage', {
        pagePath: pagePath
      }));
    }
  };
};
var ActivationModal = /*#__PURE__*/function (_PureComponent) {
  function ActivationModal() {
    var _this;
    _classCallCheck(this, ActivationModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ActivationModal, [].concat(args));
    _defineProperty(_this, "state", {
      error: '',
      loading: false
    });
    _defineProperty(_this, "handleSubmit", function (values) {
      var _this$props = _this.props,
        match = _this$props.match,
        postActivationCode = _this$props.postActivationCode;
      postActivationCode(String(match.params.projectSlug), values);
      _this.setState({
        loading: true
      });
    });
    return _this;
  }
  _inherits(ActivationModal, _PureComponent);
  return _createClass(ActivationModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
        postActivationCodeRequest = _this$props2.postActivationCodeRequest,
        openNextModal = _this$props2.openNextModal,
        getNewSettingsAndPage = _this$props2.getNewSettingsAndPage,
        match = _this$props2.match;
      var loading = this.state.loading;
      if (postActivationCodeRequest && postActivationCodeRequest.networkStatus === 'success') {
        openNextModal({
          type: 'firstWelcomeCJ2'
        });
        getNewSettingsAndPage(String(match.params.projectSlug));
      }
      if (postActivationCodeRequest && postActivationCodeRequest.networkStatus === 'failed' && loading) {
        var error;
        switch (get(postActivationCodeRequest, 'errorBody.message')) {
          case 'Activation-code not found':
            error = 'Deze activatiecode is niet juist.';
            break;
          default:
            error = 'Er is iets mis gegaan.';
            break;
        }
        this.setState({
          error: error,
          loading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var renderWidth = this.props.renderWidth;
      var _this$state = this.state,
        loading = _this$state.loading,
        error = _this$state.error;
      var activationForm = [{
        categoryTitle: 'Activatiecode invoeren',
        options: [{
          id: 'activationCode',
          name: 'activationCode',
          required: true,
          title: 'Vul hier de activatiecode in',
          type: 'text'
        }]
      }];
      return __jsx(Container, {
        "data-id": "dashboard_ActivationModal_Container"
      }, __jsx(InnerContainer, {
        "data-id": "dashboard_ActivationModal_InnerContainer"
      }, __jsx(Title, {
        "data-id": "dashboard_ActivationModal_Title"
      }, "Speciaal voor kopers: activeer je account"), __jsx(IntroText, {
        "data-id": "dashboard_ActivationModal_IntroText"
      }, "Ben je een trotse toekomstige bewoner van dit project? Dan heb je mogelijk al een activatiecode ontvangen van je woonadviseur. Die activatiecode kun je hieronder invoeren om toegang te krijgen tot Mijn Homestudios voor kopers. Op deze persoonlijke omgeving kun je onder meer direct communiceren met je Homestudios woonadviseur, jezelf alvast voorstellen aan de buren en meepraten op het forum.", __jsx("div", {
        "data-id": "dashboard_ActivationModal_div"
      }, "Heb je een woning gekocht, maar nog geen contact gehad met de Woonadviseur en geen activatiecode ontvangen? Neem dan contact met ons op.")), error && __jsx(FormError, {
        "data-id": "dashboard_ActivationModal_FormError"
      }, error), __jsx(FormGenerator, {
        fields: activationForm,
        submitLabel: "Activeren",
        loadingLabel: "aanvraag wordt verwerkt",
        submitFn: this.handleSubmit,
        loading: loading,
        "data-id": "dashboard_ActivationModal_FormGenerator"
      })), __jsx(BannerContainer, {
        "data-id": "dashboard_ActivationModal_BannerContainer"
      }, __jsx(BannerBlock, {
        title: "Na activatie:",
        renderWidth: renderWidth,
        banners: [{
          leader: 'Helpen woonontwerpen je bij het maken van keuzes voor jouw nieuwe thuis.',
          media: '/images/bannerblok-woonontwerp.png'
        }, {
          leader: 'Communiceer je direct met de woonadviseur en maak je kennis met de toekomstige buren.',
          media: '/images/bannerblok-communiceer.png'
        }, {
          leader: 'Beschik je over een eigen planning en beheer je belangrijke documenten op één plaats',
          media: '/images/bannerblok-documenten.png'
        }],
        "data-id": "dashboard_ActivationModal_BannerBlock"
      })));
    }
  }]);
}(PureComponent);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(ActivationModal));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  background-color: #fff;\n  padding-bottom: 100rem;\n  ", " ", ";\n"])), shadows.boxPrimary, toBreakpoint.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding-bottom: 60rem;\n  "]))), toBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-bottom: 40rem;\n  "]))));
var InnerContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 80rem 200rem 80rem 200rem;\n\n  ", " ", ";\n"])), toBreakpoint.lg(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    padding: 60rem 70rem 60rem 70rem;\n  "]))), toBreakpoint.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    padding: 20rem 20rem 40rem 20rem;\n  "]))));
var Title = styled.h3(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n  margin-top: 0;\n"])), textStyles.sectionTitle, colorPalette.headerGrey);
var IntroText = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-bottom: -20rem;\n  font-weight: normal;\n  max-width: 700rem;\n\n  > div {\n    margin-top: 10rem;\n  }\n"])), textStyles.subTitle, colorPalette.textGrey);
var FormError = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 20rem;\n  justify-content: center;\n  border: solid 1px #eee;\n  border-radius: 5rem;\n  background: ", ";\n  font-family: ", ";\n  color: red;\n  margin-top: 50px;\n  margin-bottom: -20px;\n"])), colorPalette.lightGrey, fonts.primary);
var BannerContainer = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  margin-top: 4rem;\n  padding-left: 100rem;\n  padding-right: 100rem;\n  ", " ", ";\n"])), toBreakpoint.lg(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n    padding-left: 30rem;\n    padding-right: 30rem;\n  "]))), toBreakpoint.md(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    padding-top: 20rem;\n    padding-left: 10rem;\n    padding-right: 10rem;\n  "]))));